import { mindBenderConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...mindBenderConfig,
    maxTrials: 18,
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
};
export const SHAPES = ['◆', '●', '▲', '★', '■'];
export const HUES = ['red', 'blue', 'green', 'amber'];
export const HUE_HEX = {
    red: '#c64a3f',
    blue: '#3a72b8',
    green: '#5b8c5a',
    amber: '#d4a93a',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, matrixSize: 2, nCandidates: 4, rules: ['shape'], label: '1 règle 2×2' };
    }
    if (level <= 20) {
        return { level, matrixSize: 2, nCandidates: 4, rules: ['shape', 'hue'], label: '2 règles 2×2' };
    }
    if (level <= 30) {
        return { level, matrixSize: 3, nCandidates: 5, rules: ['shape', 'hue'], label: '2 règles 3×3' };
    }
    if (level <= 40) {
        return { level, matrixSize: 3, nCandidates: 6, rules: ['shape', 'hue', 'count'], label: '3 règles' };
    }
    return { level, matrixSize: 3, nCandidates: 6, rules: ['shape', 'hue', 'count'], label: 'Combinaisons fines' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    preMatrixMs: 600,
    feedbackMs: 1200,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: 'mind-bender',
    paradigm: 'Matrix reasoning (Raven Progressive Matrices)',
    masterMage: 'Volta (foudre-logique)',
    category: 'foudre_logique',
    goal: 'Raisonnement fluide — décoder règles génératives. Honnêteté radicale : pas de claim QI.',
};
//# sourceMappingURL=params.js.map